export const MODULE_NAME = 'home'
